var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"value":_vm.appointment.video_medium,"label":"Video Medium","items":_vm.video_mediums},on:{"input":function (v) { return _vm.$emit('update', 'video_medium', v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }